module.exports = __webpack_public_path__ + "img/ev-drivers-dark.95b13216.webp";